import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Input } from 'antd';

import './index.css';
import DatePicker, { DateObject, getAllDatesInRange } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import "react-multi-date-picker/styles/colors/green.css"
import { CloseCircleFilled } from '@ant-design/icons';
import { BiDice1 } from 'react-icons/bi';
import moment from 'jalali-moment'
import { persianToLatin } from '../../../utils/persianToLatin ';
import DatePickerInput from './DatePickerInput';

const DatePickerInputForFilter = (props: any) => {
    let { AzTarixValue, handleChangeTarix, TaTarixValue = "", isRangeState, onei } = props;
    const [AzTarix, setAzTarix] = useState<any>(AzTarixValue || "")
    const [TaTarix, setTaTarix] = useState<any>(TaTarixValue || "")

    const [isRange, setIsRange] = useState<any>(isRangeState)
    const handleAzTarixChange = (v: any) => {
        let vTarix: any = []
        if (isRange)
            vTarix = [v.length > 0 ? v[0] : '', TaTarix]
        else
            vTarix = [...v]

        if (vTarix.every((item: any) => item === ''))
            vTarix = []
        setAzTarix(v)
        onHandleChangeTarixValue(vTarix)
    }

    const handleTaTarixChange = (v: any) => {
        let vTarix: any = []
        if (isRange)
            vTarix = [AzTarix, v.length > 0 ? v[0] : '']
        else
            vTarix = [AzTarix]

        if (vTarix.every((item: any) => item === ''))
            vTarix = []
        setTaTarix(v)
        onHandleChangeTarixValue(vTarix)
    }
    const onHandleChangeTarixValue = (v: any) => {
        handleChangeTarix(v, isRange)
    }

    const oneIsCahnge = (v: any) => {
        setIsRange(v.target.checked)
        onei(v.target.checked)
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 4 }}>
                <span>انتخاب محدوده:</span>
                <Checkbox defaultChecked={isRange} checked={isRange} onChange={(v) => oneIsCahnge(v)} />
            </div>
            <div style={{ display: 'flex' }}>
                <DatePickerInput
                    value={AzTarix}
                    one={handleAzTarixChange}
                    style={{ width:isRange?'98%':'100%' }}
                />
                {isRange &&
                    <DatePickerInput
                        value={TaTarix}
                        one={handleTaTarixChange}
                        style={{  width:'98%' }}
                    />
                }
            </div>
        </div>
    )
};

export default React.memo(DatePickerInputForFilter);


